import { useEffect } from "react";
import ConfidentialityPoliticsPageElement from "../components/confidentialityPoliticsPage/ConfidentialityPoliticsPageElement";
import { scrollToTop } from '../utils/visualHelpers'

const ConfidentialityPoliticsPage = () => {

  useEffect(() => {
    scrollToTop()
  }, [])

  return (
    <main className="main global-px text-justify flex flex-col gap-2 pb-8">
      <ConfidentialityPoliticsPageElement
        type="intro"
        title={<>Politique de Confidentialité du site <i className="italic text-darkOrange">À vos souhaits</i></>}
        texts={`Nous vous informons que ce site est toujours en développement et n'a pas vocation à être utilisé en l'état par des personnes ne faisant pas partie de l'équipe de développeurs assignés sur ce projet.`}
      />
      <ConfidentialityPoliticsPageElement
        type="section1"
        title="Définitions"
        texts={[
          `L'Éditeur : La personne, physique ou morale, qui édite les services de communication au public en ligne.`,
          `Le Site : L'ensemble des sites, pages Internet et services en ligne proposés par l'Éditeur.`,
          `L'Utilisateur : La personne utilisant le Site et les services.`,
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="1- Nature des données collectées"
        texts={[
          [
            `Dans le cadre de l'utilisation des Sites, l'Éditeur est susceptible de collecter les catégories de données suivantes concernant ses Utilisateurs :`, [
              `Données d'état-civil, d'identité, d'identification...`,
            ]],
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="2- Communication des données personnelles à des tiers"
        texts={[
          [
            `Pas de communication à des tiers`, [
              `Vos données ne font l'objet d'aucune communication à des tiers. Vous êtes toutefois informés qu'elles pourront être divulguées en application d'une loi, d'un règlement ou en vertu d'une décision d'une autorité réglementaire ou judiciaire compétente.`,
            ]],
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="3- Information préalable pour la communication des données personnelles à des tiers en cas de fusion / absorption"
        texts={[
          [
            `Information préalable et possibilité d’opt-out avant et après la fusion / acquisition`, [
              `Dans le cas où nous prendrions part à une opération de fusion, d’acquisition ou à toute autre forme de cession d’actifs, nous nous engageons à garantir la confidentialité de vos données personnelles et à vous informer avant que celles-ci ne soient transférées ou soumises à de nouvelles règles de confidentialité.`,
            ]],
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="4- Agrégation des données"
        texts={[
          [
            `Agrégation avec des données non personnelles`, [
              `Nous pouvons publier, divulguer et utiliser les informations agrégées (informations relatives à tous nos Utilisateurs ou à des groupes ou catégories spécifiques d'Utilisateurs que nous combinons de manière à ce qu'un Utilisateur individuel ne puisse plus être identifié ou mentionné) et les informations non personnelles à des fins d'analyse du secteur et du marché, de profilage démographique, à des fins promotionnelles et publicitaires et à d'autres fins commerciales.`,
            ]], [
            `Agrégation avec des données personnelles disponibles sur les comptes sociaux de l'Utilisateur`, [
              `Si vous connectez votre compte à un compte d’un autre service afin de faire des envois croisés, ledit service pourra nous communiquer vos informations de profil, de connexion, ainsi que toute autre information dont vous avez autorisé la divulgation. Nous pouvons agréger les informations relatives à tous nos autres Utilisateurs, groupes, comptes, aux données personnelles disponibles sur l’Utilisateur.`
            ]
          ]
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="5- Collecte des données d'identité"
        texts={[
          [
            `Utilisation d'un pseudonyme`, [
              `L’utilisation du Site nécessite une inscription sans identification préalable. Elle peut s’effectuer sans que vous ne communiquiez de données nominatives vous concernant (nom, prénom, adresse, etc). Vous pouvez utiliser le pseudonyme de votre choix.`,
            ]],
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="6- Collecte des données d'identification"
        texts={[
          [
            `Utilisation de l'identifiant de l'utilisateur pour proposition de mise
          en relation et offres commerciales`, [
              `Nous utilisons vos identifiants électroniques pour rechercher des relations présentes par connexion, par adresse mail ou par services. Nous pouvons utiliser vos informations de contact pour permettre à d'autres personnes de trouver votre compte, notamment via des services tiers et des applications clientes. Vous pouvez télécharger votre carnet d'adresses afin que nous soyons en mesure de vous aider à trouver des connaissances sur notre réseau ou pour permettre à d'autres Utilisateurs de notre réseau de vous trouver. Nous pouvons vous proposer des suggestions, à vous et à d'autres Utilisateurs du réseau, à partir des contacts importés de votre carnet d’adresses. Nous sommes susceptibles de travailler en partenariat avec des sociétés qui proposent des offres incitatives. Pour prendre en charge ce type de promotion et d'offre incitative, nous sommes susceptibles de partager votre identifiant électronique.`,
            ]],
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="7- Collecte des données du terminal"
        texts={[
          [
            `Aucune collecte des données techniques`, [
              `Nous ne collectons et ne conservons aucune donnée technique de votre appareil (adresse IP, fournisseur d'accès à Internet...).`,
            ]],
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="8- Cookies"
        texts={[
          [
            `Durée de conservation des cookies`, [
              `Conformément aux recommandations de la CNIL, la durée maximale de conservation des cookies est de 13 mois au maximum après leur premier dépôt dans le terminal de l'Utilisateur, tout comme la durée de la validité du consentement de l’Utilisateur à l’utilisation de ces cookies. La durée de vie des cookies n’est pas prolongée à chaque visite. Le consentement de l’Utilisateur devra donc être renouvelé à l'issue de ce délai.`,
            ]], [
            `Finalité des cookies`, [
              `Les cookies peuvent être utilisés pour des fins statistiques notamment pour optimiser les services rendus à l'Utilisateur, à partir du traitement des informations concernant la fréquence d'accès, la personnalisation des pages ainsi que les opérations réalisées et les informations consultées.`,
              `Vous êtes informé que l'Éditeur est susceptible de déposer des cookies sur votre terminal. Le cookie enregistre des informations relatives à la navigation sur le service (les pages que vous avez consultées, la date et l'heure de la consultation...) que nous pourrons lire lors de vos visites ultérieures.`
            ]
          ], [
            `Opt-in pour le dépôt de cookies`, [
              `Nous n'utilisons pas de cookies. Si nous devions en utiliser à l’avenir, vous en seriez informé préalablement et auriez la possibilité de désactiver ces cookies.`
            ]
          ]
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="9- Conservation des données techniques"
        texts={[
          [
            `Durée de conservation des données techniques`, [
              `Les données techniques sont conservées pour la durée strictement nécessaire à la réalisation des finalités visées ci-avant.`,
            ]],
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="10- Délai de conservation des données personnelles et d'anonymisation"
        texts={[
          [
            `Conservation des données pendant la durée de la relation contractuelle`, [
              `Conformément à l'article 6-5° de la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, les données à caractère personnel faisant l'objet d'un traitement ne sont pas conservées au-delà du temps nécessaire à l'exécution des obligations définies lors de la conclusion du contrat ou de la durée prédéfinie de la relation contractuelle.`,
            ]], [
            `Conservation des données anonymisées au delà de la relation contractuelle / après la suppression du compte`, [
              `Nous conservons les données personnelles pour la durée strictement nécessaire à la réalisation des finalités décrites dans les présentes Politiques de confidentialité. Au-delà de cette durée, elles seront anonymisées et conservées à des fins exclusivement statistiques et ne donneront lieu à aucune exploitation, de quelque nature que ce soit.`
            ]
          ], [
            `Suppression des données après suppression du compte`, [
              `Des moyens de purge de données sont mis en place afin d'en prévoir la suppression effective dès lors que la durée de conservation ou d'archivage nécessaire à l'accomplissement des finalités déterminées ou imposées est atteinte. Conformément à la loi n°78-17 du 6 janvier 1978 relative à l'informatique, aux fichiers et aux libertés, vous disposez par ailleurs d'un droit de suppression sur vos données que vous pouvez exercer à tout moment en prenant contact avec l'Éditeur.`
            ]
          ], [
            `Suppression des données après 3 ans d'inactivité`, [
              `Pour des raisons de sécurité, si vous ne vous êtes pas authentifié sur le Site pendant une période de trois ans, vous recevrez un e-mail vous invitant à vous connecter dans les plus brefs délais, sans quoi vos données seront supprimées de nos bases de données.`
            ]
          ]
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="11- Suppression du compte"
        texts={[
          [
            `Suppression du compte à la demande`, [
              `L'Utilisateur a la possibilité de supprimer son Compte à tout moment, par simple demande à l'Éditeur OU par le menu de suppression de Compte présent dans les paramètres du Compte le cas échéant.`,
            ]], [
            `Suppression du compte en cas de violation de la Politique de Confidentialité`, [
              `En cas de violation d'une ou de plusieurs dispositions de la Politique de Confidentialité ou de tout autre document incorporé aux présentes par référence, l'Éditeur se réserve le droit de mettre fin ou restreindre sans aucun avertissement préalable et à sa seule discrétion, votre usage et accès aux services, à votre compte et à tous les Sites.`
            ]
          ]
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="12- Indications en cas de faille de sécurité décelée par l'Editeur"
        texts={[
          [
            `Information de l'Utilisateur en cas de faille de sécurité`, [
              `Nous nous engageons à mettre en oeuvre toutes les mesures techniques et organisationnelles appropriées afin de garantir un niveau de sécurité adapté au regard des risques d'accès accidentels, non autorisés ou illégaux, de divulgation, d'altération, de perte ou encore de destruction des données personnelles vous concernant. Dans l'éventualité où nous prendrions connaissance d'un accès illégal aux données personnelles vous concernant stockées sur nos serveurs ou ceux de nos prestataires, ou d'un accès non autorisé ayant pour conséquence la réalisation des risques identifiés ci-dessus, nous nous engageons à : Vous notifier l'incident dans les plus brefs délais ; Examiner les causes de l'incident et vous en informer ; Prendre les mesures nécessaires dans la limite du raisonnable afin d'amoindrir les effets négatifs et préjudices pouvant résulter dudit incident.`,
            ]], [
            `Limitation de la responsabilité`, [
              `En aucun cas les engagements définis au point ci-dessus relatifs à la notification en cas de faille de sécurité ne peuvent être assimilés à une quelconque reconnaissance de faute ou de responsabilité quant à la survenance de l'incident en question.`
            ]
          ]
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="13- Transfert des données personnelles à l'étranger"
        texts={[
          [
            `Pas de transfert en dehors de l'Union européenne`, [
              `L'Éditeur s'engage à ne pas transférer les données personnelles de ses Utilisateurs en dehors de l'Union européenne.`,
            ]], [
            `Information CNIL`, [
              `Plus d'informations sont disponibles à cette adresse : https://www.cnil.fr/fr/la-protection-des-donnees-dans-le-monde`
            ]
          ]
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="14- Modification de la politique de confidentialité"
        texts={[
          [
            `En cas de modification de la présente Politique de Confidentialité, engagement de ne pas baisser le niveau de confidentialité de manière substantielle sans l'information préalable des personnes concernées`, [
              `Nous nous engageons à vous informer en cas de modification substantielle de la présente Politique de Confidentialité, et à ne pas baisser le niveau de confidentialité de vos données de manière substantielle sans vous en informer et obtenir votre consentement.`,
            ]],
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="15- Droit applicable et modalités de recours"
        texts={[
          [
            `Clause d'arbitrage`, [
              `Vous acceptez expressément que tout litige susceptible de naître du fait de la présente Politique de Confidentialité, notamment de son interprétation ou de son exécution, relèvera d'une procédure d'arbitrage soumise au règlement de la plateforme d'arbitrage choisie d'un commun accord, auquel vous adhérerez sans réserve.`,
            ]],
        ]}
      />
      <ConfidentialityPoliticsPageElement
        type="section2"
        title="16- Portabilité des données"
        texts={[
          [
            `Portabilité des données`, [
              `L'Éditeur s'engage à vous offrir la possibilité de vous faire restituer l'ensemble des données vous concernant sur simple demande. L'Utilisateur se voit ainsi garantir une meilleure maîtrise de ses données, et garde la possibilité de les réutiliser. Ces données devront être fournies dans un format ouvert et aisément réutilisable.`,
            ]],
        ]}
      />
    </main>
  );
};

export default ConfidentialityPoliticsPage;
